import { CAMPAIGN_TYPE } from 'config/constants';

export default function checkAppDestination(type) {
  typeof window !== 'undefined' && localStorage.setItem('popupOpen', false);
  const url =
    type === CAMPAIGN_TYPE.PLAN
      ? '/plan_user'
      : type === CAMPAIGN_TYPE.POINT
      ? '/point'
      : type === CAMPAIGN_TYPE.CONTACT
      ? '/contactafterlogin'
      : type === CAMPAIGN_TYPE.AGE_VERIFICATION
      ? '/contactageverification'
      : type === CAMPAIGN_TYPE.INFO2
      ? '/info/info2'
      : type === CAMPAIGN_TYPE.INFO3
      ? '/info/info3'
      : type === CAMPAIGN_TYPE.INFO4
      ? '/info/info4'
      : type === CAMPAIGN_TYPE.INFO5
      ? '/info/info5'
      : type === CAMPAIGN_TYPE.INFO6
      ? '/info/info6'
      : type === CAMPAIGN_TYPE.INFO7
      ? '/info/info7'
      : type === CAMPAIGN_TYPE.INFO8
      ? '/info/info8'
      : type === CAMPAIGN_TYPE.INFO1
      ? '/info/info1'
      : '#';
  return url;
}
